import * as actionType from "../constants";
export const stopPopup =
  (any = null) =>
  async (dispatch) => {
    if (any === "status") {
      return { board: false };
    }
    dispatch({ type: actionType.POPUP_STOP_DETAILS });
  };
